import { useEffect } from "react";
import { useLocation } from "react-router";

import { useConfiguration } from "@citrine/resources/configuration";

import { useCatalystContext } from "#src/contexts/catalyst";

export const GRAPH_BUILDER_PATH = "graph-builder";
const GRAPH_BUILDER_REGEX =
  /^\/projects\/[^/]+\/predictors\/[^/]+\/graph-builder($|\/)/;
const PREDICTOR_SHOW_REGEX = /^\/projects\/[^/]+\/predictors\/[^/]+/;

/**
 * Needs to be mounted within the application routing, allows us to avoid adding
 * routing in our unit tests.
 **/
export function SetCatalystModelExpertAvailability() {
  const { setModelExpertEnabled, setChanges } = useCatalystContext();
  const enableModelAssistant = useConfiguration("enableModelAssistant");
  const { pathname } = useLocation();

  // Because the predictor new/show page unmounts the PredictorEditor component
  // when the predictor version is changed, we can't rely on the presence of
  // the predictor state (set and removed by the PredictorEditor) to determine
  // whether or not to enable the Model Expert. This approach checks the URL
  // in conjunction with the `enableModelAssistant` feature flag to determine
  // whether use of the Model Expert is allowed.
  useEffect(() => {
    const onModelBuilderPage = GRAPH_BUILDER_REGEX.test(pathname);
    setModelExpertEnabled(onModelBuilderPage && Boolean(enableModelAssistant));
  }, [enableModelAssistant, pathname, setModelExpertEnabled]);

  // Not sure if this is really necessary given how fast you would have to click
  // away from the predictor show page, but I suppose it's dependent on network
  // latency and the particular predictor. We want to avoid having stale
  // `changes` if the user applies changes to a non-draft predictor
  //  and leaves the page before the draft version loads.
  useEffect(() => {
    const onPredictorShowPage = PREDICTOR_SHOW_REGEX.test(pathname);
    if (!onPredictorShowPage) {
      setChanges(undefined);
    }
  }, [pathname, setChanges]);

  return null;
}
